import React from 'react';
import { Box, Typography } from '@mui/material';

interface QRCodeProps {
  value: string;
  size?: number;
  level?: 'L' | 'M' | 'Q' | 'H';
  style?: React.CSSProperties;
}

// Lazy load QRCodeSVG component
let QRCodeComponent: React.ComponentType<any> | null = null;

const loadQRCode = async () => {
  if (QRCodeComponent) return QRCodeComponent;
  
  try {
    const module = await import('react-qr-code');
    QRCodeComponent = module.QRCodeSVG || module.default;
    return QRCodeComponent;
  } catch (error) {
    console.warn('react-qr-code package not installed');
    return null;
  }
};

export const QRCode: React.FC<QRCodeProps> = ({ value, size = 250, level = 'M', style }) => {
  const [Component, setComponent] = React.useState<React.ComponentType<any> | null>(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    loadQRCode().then((comp) => {
      setComponent(comp);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Box sx={{ 
        width: size, 
        height: size, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        bgcolor: 'grey.100',
        borderRadius: 1
      }}>
        <Typography variant="caption" color="text.secondary">
          Loading QR code...
        </Typography>
      </Box>
    );
  }

  if (!Component) {
    return (
      <Box sx={{ 
        width: size, 
        height: size, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        bgcolor: 'grey.100',
        borderRadius: 1
      }}>
        <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', p: 2 }}>
          QR Code unavailable. Please install react-qr-code package.
        </Typography>
      </Box>
    );
  }

  return <Component value={value} size={size} level={level} style={style} />;
};

